export const sportsCategories = [
  { slug: 'football', name: '足球', icon: 'ri-football-line', matchCount: 128, description: '全球顶级足球联赛实时投注' },
  { slug: 'basketball', name: '篮球', icon: 'ri-basketball-line', matchCount: 86, description: 'NBA、CBA等篮球赛事直播' },
  { slug: 'tennis', name: '网球', icon: 'ri-base-station-line', matchCount: 54, description: 'ATP、WTA网球赛事全覆盖' },
  { slug: 'esports', name: '电竞', icon: 'ri-gamepad-line', matchCount: 42, description: 'LOL、DOTA2等电竞投注' },
  { slug: 'baseball', name: '棒球', icon: 'ri-base-station-line', matchCount: 31, description: 'MLB美职棒赛事投注' },
  { slug: 'boxing', name: '拳击', icon: 'ri-boxing-line', matchCount: 18, description: '世界拳王争霸赛实时赔率' },
];

export const liveMatches = [
  {
    id: 'match-1',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeLogo: 'https://readdy.ai/api/search-image?query=Real%20Madrid%20football%20club%20crest%20logo%20white%20background%20minimal%20flat%20design%20clean%20vector%20style&width=120&height=120&seq=match-home-01&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=FC%20Barcelona%20football%20club%20crest%20logo%20white%20background%20minimal%20flat%20design%20clean%20vector%20style&width=120&height=120&seq=match-away-01&orientation=squarish',
    score: '2 : 1',
    minute: '76\'',
    league: '西甲联赛',
    category: 'football',
    odds: { home: 2.10, draw: 3.40, away: 3.20 },
    isLive: true,
  },
  {
    id: 'match-2',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeLogo: 'https://readdy.ai/api/search-image?query=LA%20Lakers%20basketball%20team%20logo%20purple%20gold%20white%20background%20minimal%20flat%20design&width=120&height=120&seq=match-home-02&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Golden%20State%20Warriors%20basketball%20team%20logo%20blue%20gold%20white%20background%20minimal%20flat%20design&width=120&height=120&seq=match-away-02&orientation=squarish',
    score: '98 : 102',
    minute: 'Q3 4:21',
    league: 'NBA常规赛',
    category: 'basketball',
    odds: { home: 1.85, away: 1.95 },
    isLive: true,
  },
  {
    id: 'match-3',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeLogo: 'https://readdy.ai/api/search-image?query=professional%20tennis%20player%20icon%20logo%20white%20background%20minimal%20flat%20design%20clean&width=120&height=120&seq=match-home-03&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=tennis%20player%20racket%20icon%20logo%20white%20background%20minimal%20flat%20design%20clean&width=120&height=120&seq=match-away-03&orientation=squarish',
    score: '6:4, 3:2',
    minute: 'Set 2',
    league: 'ATP大师赛',
    category: 'tennis',
    odds: { home: 1.65, away: 2.25 },
    isLive: true,
  },
  {
    id: 'match-4',
    homeTeam: 'T1战队',
    awayTeam: 'GEN.G',
    homeLogo: 'https://readdy.ai/api/search-image?query=esports%20team%20logo%20T1%20red%20white%20background%20minimal%20flat%20design%20clean&width=120&height=120&seq=match-home-04&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=esports%20team%20logo%20GEN%20gold%20white%20background%20minimal%20flat%20design%20clean&width=120&height=120&seq=match-away-04&orientation=squarish',
    score: '1 : 1',
    minute: 'BO5 G3',
    league: 'LCK春季赛',
    category: 'esports',
    odds: { home: 2.30, away: 1.60 },
    isLive: true,
  },
  {
    id: 'match-5',
    homeTeam: '曼彻斯特城',
    awayTeam: '利物浦',
    homeLogo: 'https://readdy.ai/api/search-image?query=Manchester%20City%20football%20club%20crest%20logo%20sky%20blue%20white%20background%20minimal%20flat%20design&width=120&height=120&seq=match-home-05&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Liverpool%20FC%20football%20club%20crest%20logo%20red%20white%20background%20minimal%20flat%20design&width=120&height=120&seq=match-away-05&orientation=squarish',
    score: '0 : 0',
    minute: '32\'',
    league: '英超联赛',
    category: 'football',
    odds: { home: 2.50, draw: 3.20, away: 2.80 },
    isLive: true,
  },
  {
    id: 'match-6',
    homeTeam: '波士顿凯尔特人',
    awayTeam: '密尔沃基雄鹿',
    homeLogo: 'https://readdy.ai/api/search-image?query=Boston%20Celtics%20basketball%20team%20logo%20green%20white%20background%20minimal%20flat%20design&width=120&height=120&seq=match-home-06&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Milwaukee%20Bucks%20basketball%20team%20logo%20green%20cream%20white%20background%20minimal%20flat%20design&width=120&height=120&seq=match-away-06&orientation=squarish',
    score: 'VS',
    minute: '明日 09:30',
    league: 'NBA常规赛',
    category: 'basketball',
    odds: { home: 1.72, away: 2.10 },
    isLive: false,
  },
];

export const upcomingMatches = [
  {
    id: 'up-1',
    homeTeam: '拜仁慕尼黑',
    awayTeam: '多特蒙德',
    league: '德甲联赛',
    category: 'football',
    time: '2026-08-08 21:30',
    odds: { home: 1.55, draw: 4.20, away: 5.50 },
  },
  {
    id: 'up-2',
    homeTeam: '费城76人',
    awayTeam: '迈阿密热火',
    league: 'NBA常规赛',
    category: 'basketball',
    time: '2026-08-08 08:00',
    odds: { home: 1.90, away: 1.90 },
  },
  {
    id: 'up-3',
    homeTeam: '纳达尔',
    awayTeam: '西西帕斯',
    league: 'ATP巡回赛',
    category: 'tennis',
    time: '2026-08-09 16:00',
    odds: { home: 2.10, away: 1.72 },
  },
  {
    id: 'up-4',
    homeTeam: '巴黎圣日耳曼',
    awayTeam: '马赛',
    league: '法甲联赛',
    category: 'football',
    time: '2026-08-09 03:00',
    odds: { home: 1.40, draw: 4.80, away: 7.00 },
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '2026世界杯预选赛：亚洲区最新出线形势深度分析',
    excerpt: '随着世界杯预选赛进入白热化阶段，亚洲区各队出线形势逐渐明朗。本文将为您全面解析各小组积分情况及关键对决。',
    content: `<p>2026年世界杯预选赛亚洲区比赛已经进入最关键的阶段。经过多轮激烈角逐，各小组的出线形势逐渐明朗。本文将为您全面解析各小组积分情况、关键对决以及影响出线的各种因素。</p>
    <h3>小组积分概况</h3>
    <p>在A组中，日本队以全胜战绩稳居榜首，韩国队紧随其后。两队之间的直接对话将决定小组头名的归属。值得注意的是，中国队在本届预选赛中表现出色，目前位列小组第三，仍有很大机会争夺出线名额。</p>
    <p>B组的竞争更为激烈，伊朗、沙特阿拉伯和澳大利亚三强争霸，积分差距在3分以内，每一场比赛都可能改变排名格局。</p>
    <h3>关键对决分析</h3>
    <p>接下来几轮比赛中，有几场关键对决值得特别关注：日本对阵韩国的东亚德比、中国对阵澳大利亚的生死战，以及伊朗与沙特的中东大战。这些比赛的结果将直接影响最终的世界杯参赛名额分配。</p>
    <p>从赔率数据来看，日本队被普遍看好能够以小组第一出线，而中国队虽然面临挑战，但近期状态回升，在bb体育平台的赔率不断走低，说明市场对其信心在增强。</p>
    <h3>数据解读</h3>
    <p>从各项数据指标来看，日本队在进攻端场均进球2.8个，防守端仅失0.3球，攻防两端均表现卓越。韩国队则在控球率上占据优势，场均控球率达到62%。中国队则在抢断和拦截数据上位列亚洲区前三。</p>
    <h3>出线预测</h3>
    <p>综合各队实力、赛程和当前积分，我们预测日本、韩国、伊朗和沙特阿拉伯最有可能获得直接出线名额，而中国和澳大利亚将争夺附加赛资格。当然，足球比赛充满变数，任何预测都存在不确定性，这正是体育的魅力所在。</p>`,
    category: 'football',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%20football%20stadium%20atmosphere%20with%20national%20flags%20fans%20cheering%20dramatic%20lighting%20sport%20photography%20vibrant%20colors%20action%20shot%20wide%20angle&width=800&height=450&seq=article-1-cover&orientation=landscape',
    author: '体育观察员',
    date: '2026-08-05',
    tags: ['世界杯', '预选赛', '亚洲足球', '出线分析'],
    views: 12580,
    relatedArticles: ['article-3', 'article-5', 'article-8'],
  },
  {
    id: 'article-2',
    title: 'NBA新赛季前瞻：湖人勇士谁能问鼎总冠军？',
    excerpt: 'NBA新赛季即将拉开帷幕，经过休赛期的阵容调整，各支球队实力发生了显著变化。湖人、勇士、凯尔特人等传统强队谁能笑到最后？',
    content: `<p>NBA 2026-2027赛季即将拉开帷幕，经过一个充满交易和签约的休赛期，联盟格局发生了不少变化。本文将从前瞻性的角度，分析各支强队的实力变化和夺冠前景。</p>
    <h3>湖人队：詹眉组合的最后冲刺</h3>
    <p>洛杉矶湖人在休赛期完成了几笔关键签约，球队阵容深度得到明显补强。詹姆斯虽然年龄增长，但竞技状态依然出色，戴维斯也保持了健康。在bb体育的夺冠赔率中，湖人目前位列联盟前三。</p>
    <h3>勇士队：三分王朝的延续</h3>
    <p>金州勇士在新赛季依旧是西部最具威胁的球队之一。库里的三分投射依然是球队最致命的武器，汤普森和格林的状态也将直接影响球队的上限。</p>
    <h3>凯尔特人：年轻势力的崛起</h3>
    <p>波士顿凯尔特人拥有联盟最均衡的阵容配置，双探花组合越发成熟，加上深厚的板凳阵容，他们被视为新赛季夺冠最大热门之一。bb体育平台数据显示，凯尔特人的夺冠赔率在季前赛中不断走低。</p>`,
    category: 'basketball',
    coverImage: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20action%20shot%20two%20players%20dunking%20and%20defending%20dramatic%20arena%20lighting%20professional%20sports%20photography%20intense%20atmosphere&width=800&height=450&seq=article-2-cover&orientation=landscape',
    author: '篮球评论员',
    date: '2026-08-04',
    tags: ['NBA', '湖人', '勇士', '总冠军'],
    views: 9840,
    relatedArticles: ['article-6', 'article-9'],
  },
  {
    id: 'article-3',
    title: '欧冠淘汰赛抽签结果出炉：豪门对决引爆期待',
    excerpt: '本赛季欧冠淘汰赛抽签结果正式公布，多场强强对话引发球迷热议。皇马对阵曼城、巴萨迎战拜仁等豪门对决令人热血沸腾。',
    content: `<p>欧洲冠军联赛淘汰赛阶段的抽签仪式在瑞士尼翁落下帷幕，多场重磅对决的出炉让全球球迷兴奋不已。让我们一起来看看各场对决的看点和投注分析。</p>
    <h3>皇马 vs 曼城：欧洲之巅的较量</h3>
    <p>这无疑是本轮淘汰赛最受关注的对决。作为欧冠历史上最成功的俱乐部，皇家马德里拥有丰富的淘汰赛经验；而曼城在瓜迪奥拉的带领下，近年来在欧冠赛场上也有出色表现。bb体育数据显示，本场比赛的投注量已创下赛季新高。</p>
    <h3>其他焦点对决</h3>
    <p>巴萨与拜仁的交锋同样是经典对决的重现。此外，巴黎圣日耳曼对阵国际米兰、阿森纳迎战AC米兰也充满看点。每一场对决都充满悬念，为投注者提供了丰富的选择空间。</p>`,
    category: 'football',
    coverImage: 'https://readdy.ai/api/search-image?query=champions%20league%20trophy%20and%20football%20stadium%20with%20dramatic%20stadium%20lights%20green%20grass%20field%20professional%20sports%20photography%20grand%20scale&width=800&height=450&seq=article-3-cover&orientation=landscape',
    author: '欧冠观察家',
    date: '2026-08-03',
    tags: ['欧冠', '豪门对决', '淘汰赛', '抽签'],
    views: 15620,
    relatedArticles: ['article-1', 'article-5'],
  },
  {
    id: 'article-4',
    title: 'bb体育专属优惠：新用户注册即享888元礼包',
    excerpt: 'bb体育为新用户准备了超值注册礼包，888元投注金即刻到账。更有每日竞猜、充值返利等多重优惠等您来参与！',
    content: `<p>bb体育始终致力于为用户提供最优质的体育投注体验。为了回馈新老用户的支持，我们推出了一系列超值优惠活动。</p>
    <h3>新用户专属礼包</h3>
    <p>即日起，新注册用户即可获得888元投注礼包。礼包包含首存优惠、免费投注金和VIP体验权益，让您零门槛体验bb体育的优质服务。</p>
    <h3>每日竞猜赢大奖</h3>
    <p>参与每日赛事竞猜，预测正确的用户将有机会赢取iPhone、游戏主机等丰厚奖品。竞猜门槛低、奖励高，人人皆可参与。</p>
    <h3>充值返利不停歇</h3>
    <p>bb体育推出阶梯式充值返利活动，充值越多返利越高，最高可获得20%的额外投注金。活动长期有效，详情请查看平台活动页面。</p>`,
    category: 'promotions',
    coverImage: 'https://readdy.ai/api/search-image?query=sports%20betting%20promotion%20banner%20with%20gift%20boxes%20golden%20confetti%20celebration%20atmosphere%20luxury%20style%20red%20and%20gold%20color%20scheme%20clean%20design&width=800&height=450&seq=article-4-cover&orientation=landscape',
    author: 'bb体育运营',
    date: '2026-08-02',
    tags: ['优惠活动', '新用户', '注册礼包', '充值返利'],
    views: 32500,
    relatedArticles: ['article-7', 'article-10'],
  },
  {
    id: 'article-5',
    title: '英超联赛：曼城能否实现四连冠伟业？',
    excerpt: '曼城在最近三个赛季中展现出了统治级的表现，连续三年捧起英超冠军奖杯。新赛季他们能否延续辉煌？',
    content: `<p>曼彻斯特城在瓜迪奥拉的带领下，已经连续三个赛季夺得英超联赛冠军，创造了一段辉煌的王朝。新赛季，他们面临着来自阿森纳、利物浦等球队的强力挑战。</p>
    <h3>阵容分析</h3>
    <p>曼城在夏季转会窗口中保持了核心阵容的稳定性，同时补强了几个关键位置。哈兰德依旧是球队最犀利的得分武器，德布劳内的中场组织能力也无可替代。</p>
    <h3>竞争对手</h3>
    <p>阿森纳在阿尔特塔的调教下日益成熟，上赛季与曼城争夺冠军到最后一轮。利物浦在新赛季也进行了针对性补强。从bb体育的夺冠赔率来看，曼城虽然仍是最被看好的球队，但优势正在缩小。</p>`,
    category: 'football',
    coverImage: 'https://readdy.ai/api/search-image?query=Manchester%20City%20football%20team%20celebrating%20trophy%20lift%20stadium%20confetti%20blue%20smoke%20dramatic%20lighting%20professional%20sports%20photography&width=800&height=450&seq=article-5-cover&orientation=landscape',
    author: '英超评论员',
    date: '2026-08-01',
    tags: ['英超', '曼城', '四连冠', '瓜迪奥拉'],
    views: 11230,
    relatedArticles: ['article-1', 'article-3'],
  },
  {
    id: 'article-6',
    title: '电竞投注指南：LOL全球总决赛夺冠热门分析',
    excerpt: '英雄联盟全球总决赛即将打响，各大赛区冠军齐聚一堂。谁将是本届比赛的最大热门？bb体育为您带来专业分析。',
    content: `<p>英雄联盟全球总决赛作为电竞界最高规格的赛事，每年都吸引着全球数亿观众的关注。本届比赛汇集了各大赛区的顶尖战队，竞争异常激烈。</p>
    <h3>LCK赛区：T1的王者归来</h3>
    <p>T1本赛季在LCK赛区展现了绝对的统治力，Faker的传奇仍在延续。在bb体育的夺冠赔率中，T1稳居榜首。</p>
    <h3>LPL赛区：群雄逐鹿</h3>
    <p>LPL赛区的竞争格局更加开放，多支战队实力相当。JDG和BLG被认为是LPL最具竞争力的代表。</p>`,
    category: 'esports',
    coverImage: 'https://readdy.ai/api/search-image?query=esports%20arena%20packed%20with%20fans%20colorful%20LED%20stage%20lights%20gaming%20competition%20atmosphere%20professional%20event%20photography%20wide%20shot&width=800&height=450&seq=article-6-cover&orientation=landscape',
    author: '电竞分析师',
    date: '2026-07-30',
    tags: ['电竞', 'LOL', '全球总决赛', 'LPL'],
    views: 8900,
    relatedArticles: ['article-4', 'article-2'],
  },
  {
    id: 'article-7',
    title: 'bb体育会员专属VIP权益全面升级',
    excerpt: 'bb体育VIP会员系统全面升级，新增多项尊享权益，包括专属客服、更高提现额度、私人投注顾问等。',
    content: `<p>为了给高端用户带来更好的服务体验，bb体育对VIP会员系统进行了全面升级。新版VIP系统分为白银、黄金、钻石和至尊四个等级，每个等级都有独特的专属权益。</p>
    <h3>VIP等级权益详解</h3>
    <p>白银会员即可享受专属客服通道和优先提现服务；黄金会员额外获得每日免费投注金；钻石会员配备私人投注顾问；至尊会员更享无限提现额度和全球赛事VIP观赛席位。</p>`,
    category: 'promotions',
    coverImage: 'https://readdy.ai/api/search-image?query=luxury%20VIP%20membership%20card%20with%20gold%20accents%20dark%20elegant%20background%20premium%20lifestyle%20concept%20clean%20sophisticated%20design&width=800&height=450&seq=article-7-cover&orientation=landscape',
    author: 'bb体育运营',
    date: '2026-07-28',
    tags: ['VIP', '会员权益', '升级', '专属服务'],
    views: 7800,
    relatedArticles: ['article-4'],
  },
  {
    id: 'article-8',
    title: '网球大满贯：谁将问鼎今年美网？',
    excerpt: '美国网球公开赛即将到来，新生代选手能否撼动三巨头的统治地位？bb体育带来最全面的赛事前瞻分析。',
    content: `<p>美国网球公开赛作为年度最后一项大满贯赛事，总是充满戏剧性和悬念。今年的美网更加令人期待，新生代选手的崛起让竞争格局变得更加开放。</p>
    <h3>男单：新老对决</h3>
    <p>德约科维奇依旧是最大的夺冠热门，但阿尔卡拉斯和辛纳等新生代选手的威胁不容忽视。在bb体育的赔率榜上，德约科维奇略微领先，但年轻选手的赔率持续走低。</p>
    <h3>女单：群芳争艳</h3>
    <p>女单赛场更加开放，多位选手都有夺冠实力。斯瓦泰克、萨巴伦卡和高芙构成了夺冠的第一梯队，但黑马选手的可能性也不容小觑。</p>`,
    category: 'tennis',
    coverImage: 'https://readdy.ai/api/search-image?query=US%20Open%20tennis%20stadium%20night%20match%20floodlights%20blue%20hard%20court%20packed%20crowd%20professional%20sports%20photography%20dramatic%20atmosphere&width=800&height=450&seq=article-8-cover&orientation=landscape',
    author: '网球观察家',
    date: '2026-07-25',
    tags: ['网球', '美网', '大满贯', '德约科维奇'],
    views: 6540,
    relatedArticles: ['article-1'],
  },
  {
    id: 'article-9',
    title: 'CBA新赛季：中国篮球的新篇章',
    excerpt: 'CBA联赛新赛季即将开启，多支球队在休赛期完成重磅引援，新赛季的竞争格局将更加精彩纷呈。',
    content: `<p>中国男子篮球职业联赛（CBA）新赛季即将开赛，经历了一个充满变化的休赛期后，联赛格局发生了显著变化。</p>
    <h3>夺冠热门</h3>
    <p>广东宏远、辽宁本钢和浙江广厦依然是夺冠的最有力竞争者。广东队在休赛期引进了强力外援，辽宁队保持了核心阵容的稳定性。在bb体育的赔率数据中，这三支球队的夺冠概率合计超过60%。</p>
    <h3>黑马球队</h3>
    <p>上海久事和北京首钢在休赛期的操作也颇为亮眼，有望成为新赛季的黑马。特别是上海队，在年轻球员的培养上取得了显著成效。</p>`,
    category: 'basketball',
    coverImage: 'https://readdy.ai/api/search-image?query=CBA%20Chinese%20basketball%20league%20game%20action%20dunk%20red%20arena%20fans%20cheering%20professional%20sports%20photography%20intense%20atmosphere&width=800&height=450&seq=article-9-cover&orientation=landscape',
    author: 'CBA评论员',
    date: '2026-07-22',
    tags: ['CBA', '中国篮球', '新赛季', '广东宏远'],
    views: 5670,
    relatedArticles: ['article-2'],
  },
  {
    id: 'article-10',
    title: 'bb体育安全投注指南：保障您的资金与信息安全',
    excerpt: 'bb体育采用国际领先的安全加密技术，确保每一位用户的资金和信息安全。本文带您了解bb体育的安全保障体系。',
    content: `<p>在体育投注平台中，资金安全和信息保护是用户最为关心的问题。bb体育一直将用户安全放在首位，建立了完善的安全保障体系。</p>
    <h3>资金安全保障</h3>
    <p>bb体育采用银行级别的SSL加密技术，所有资金流转均经过多重验证。平台与多家国际知名银行合作，用户资金实行分离管理，确保每一笔资金的安全。</p>
    <h3>信息安全保护</h3>
    <p>平台严格遵守国际数据保护法规，用户个人信息采用加密存储，绝不会泄露给第三方。同时，bb体育通过了ISO 27001信息安全管理体系认证。</p>
    <h3>公平公正保障</h3>
    <p>所有赔率数据由专业团队实时更新，确保公平公正。投注系统经过第三方机构审计，杜绝任何暗箱操作的可能。</p>`,
    category: 'guide',
    coverImage: 'https://readdy.ai/api/search-image?query=cybersecurity%20shield%20digital%20protection%20concept%20modern%20technology%20abstract%20design%20clean%20professional%20style%20warm%20gold%20accents&width=800&height=450&seq=article-10-cover&orientation=landscape',
    author: 'bb体育安全团队',
    date: '2026-07-20',
    tags: ['安全', '资金保障', '信息保护', '公平公正'],
    views: 4520,
    relatedArticles: ['article-4'],
  },
];

export const promotions = [
  {
    id: 'promo-1',
    title: '新用户注册礼包',
    description: '注册即送888元投注礼包，零门槛体验',
    icon: 'ri-gift-line',
    color: 'primary',
  },
  {
    id: 'promo-2',
    title: '首存100%返还',
    description: '首次充值金额100%返还，最高返1000元',
    icon: 'ri-refund-2-line',
    color: 'accent',
  },
  {
    id: 'promo-3',
    title: '每日竞猜',
    description: '参与每日赛事竞猜，赢取丰厚大奖',
    icon: 'ri-question-answer-line',
    color: 'secondary',
  },
  {
    id: 'promo-4',
    title: 'VIP专属特权',
    description: '成为VIP会员，尊享私人投注顾问服务',
    icon: 'ri-vip-crown-line',
    color: 'primary',
  },
];

export const platformStats = [
  { label: '注册会员', value: '500万+', icon: 'ri-user-star-line' },
  { label: '日均赛事', value: '2000+', icon: 'ri-calendar-event-line' },
  { label: '年交易额', value: '100亿+', icon: 'ri-money-dollar-circle-line' },
  { label: '合作联赛', value: '50+', icon: 'ri-shake-hands-line' },
];

export const aboutFeatures = [
  {
    title: '安全稳定',
    description: '采用国际顶尖加密技术，保障交易安全与用户隐私。平台运营多年，从未发生安全事故。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '赔率最优',
    description: '专业精算团队实时调整赔率，确保竞争力。bb体育赔率在行业中始终保持领先水平。',
    icon: 'ri-line-chart-line',
  },
  {
    title: '赛事全面',
    description: '覆盖全球50+体育联赛，每天2000+赛事供选择。足球、篮球、网球、电竞等应有尽有。',
    icon: 'ri-global-line',
  },
  {
    title: '支付便捷',
    description: '支持多种支付方式，充值提现秒到账。7×24小时客服团队随时为您服务。',
    icon: 'ri-bank-card-line',
  },
  {
    title: '实时直播',
    description: '高清赛事直播，零延迟画面传输。边看边投，体验极致竞技乐趣。',
    icon: 'ri-live-line',
  },
  {
    title: '专业分析',
    description: '资深体育分析师团队提供赛事前瞻和数据解读，助您做出更明智的投注决策。',
    icon: 'ri-bar-chart-box-line',
  },
];